import { Dialog } from '@angular/cdk/dialog';
import { inject, Injectable } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';

import { firstValueFrom } from 'rxjs';

import { AlertPopUpComponent } from './alert-pop-up.component';


type TextProp = string | { key: string; params?: Record<string, any> };

export interface AlertPopUpData {
  title: TextProp;
  subtitle?: TextProp;
  label: TextProp;
  type: 'default' | 'info' | 'warning' | 'danger';
  buttons: string[];
  icon?: string;
  safeHtml?: SafeHtml;
}

export interface AlertPopUpPromptData extends AlertPopUpData {
  prompt: {
    placeholder?: string;
    initialValue?: string;
    /** Disables the confirm button while the value is blank. */
    required?: boolean;
  };
}

export interface AlertPopUpConfig {
  restoreFocus?: boolean;
}

@Injectable({ providedIn: 'root' })
export class AlertPopUpService {

  private dialog = inject(Dialog);

  async confirm(obj: AlertPopUpData, config?: AlertPopUpConfig): Promise<boolean | undefined> {
    const dialogRef = this.dialog.open<boolean>(AlertPopUpComponent, {
      data: obj,
      ...config,
    });

    const result = await firstValueFrom(dialogRef.closed);

    return result ?? undefined;
  }

  async prompt(obj: AlertPopUpPromptData, config?: AlertPopUpConfig): Promise<string | null> {
    const dialogRef = this.dialog.open<string | null>(AlertPopUpComponent, {
      data: obj,
      ...config,
    });

    const result = await firstValueFrom(dialogRef.closed);

    return result ?? null;
  }
}
